import { useQuery } from "@tanstack/react-query";
import { getNeighbourhoodSuggestions } from "../../apis/search";

export function useNeighborhoodSuggestions(
  latitude?: number | null,
  longitude?: number | null,
) {
  return useQuery({
    queryKey: ["neighbourhoodSuggestions", latitude ?? null, longitude ?? null],
    queryFn: () => getNeighbourhoodSuggestions(undefined, latitude, longitude),
  });
}
